import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import EventSummary from './EventSummary';
import { Box, Divider, Alert, AlertTitle, Link } from '@mui/material';
import { useTicketsSelected } from '@/store';
import CheckoutMap from '@/templates/plus/sections//CheckoutMap';
import useEventStatus from '@/contexts/event/useEventStatus';

export default function EventHome({ onReadMore, onTicketCategorySelected }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const { hasTickets } = useTicketsSelected();
  const { eventStatus } = useEventStatus();

  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'scroll',
      }}
    >
      <Box
        sx={{
          mr: '24px',
          ml: '24px',
          mb: 2,
        }}
      >
        <EventSummary onReadMore={onReadMore} />
      </Box>

      <Box
        sx={{
          mr: '24px',
          ml: '24px',
        }}
      ></Box>

      <Box
        sx={{
          ml: '24px',
        }}
      >
        <Divider />
      </Box>

      <Box
        sx={{
          mr: '24px',
          ml: '24px',
        }}
      >
        {eventStatus === 'active' && (
          <CheckoutMap disabledAlerts disabledSaturated onHold={() => {}} />
        )}
        {eventStatus === 'inactive' && (
          <Box
            sx={{
              mt: '24px',
            }}
          >
            <Alert
              sx={{
                '& .MuiAlert-icon': {
                  fontSize: 40,
                  color: '#1B8FFF',
                },
              }}
              severity="info"
            >
              <AlertTitle>{t('checkout.home.alerts.inactive')}</AlertTitle>
              {t('checkout.home.alerts.inactiveMsg')}
            </Alert>
          </Box>
        )}
        {eventStatus === 'expired' && (
          <Box
            sx={{
              mt: '24px',
            }}
          >
            <Alert
              sx={{
                '& .MuiAlert-icon': {
                  fontSize: 40,
                  color: '#1B8FFF',
                },
              }}
              severity="info"
            >
              <AlertTitle>{t('checkout.home.alerts.expired')}</AlertTitle>
              {t('checkout.home.alerts.expiredMsg')}{' '}
              <Link
                variant="caption"
                underline="always"
                href="https://www.boletia.com"
              >
                boletia.com
              </Link>
            </Alert>
          </Box>
        )}
      </Box>
      {show && hasTickets && (
        <Box
          sx={{
            height: '77px',
            width: '100%',
          }}
        ></Box>
      )}
    </Box>
  );
}
